export const fdefFormXNew = {
  __renderer: "new",
  formdefinition: [
    {
      control: "stepper",
      name: "schadensmeldung",
      label: "Schadenanzeige - Unbekannt",
      showSubformErrorCount: false,
      cols: "12",
      steps: [],
    },
  ],
};
